import { Template } from '../../Model/Catalog/Template';

export class MassDataChangeParameter {

  constructor(
    public fullCatalog: boolean,
    public categoryIds: string[],
    public productIds: string[],
    public template?: Template,
    public deleteItems?: boolean,
    public deleteEmptyCategories?: boolean
  ) {

  }
}
